export default __webpack_public_path__ + "static/media/ambrizalogout2.65581423.jpg";